import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import RAHome from "./pages/RAHome";
import CallingCard from "./pages/CallingCard";
import VideoReviewRecord from "./pages/VideoReviewRecord";
import VideoReviews from "./pages/VideoReviews";
import Tours from "./pages/Tours";
import TourDetail from "./pages/TourDetail";
import About from "./pages/About";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import NotFound from "./pages/NotFound";
import NepalCycling from "./pages/NepalCycling";
import Contact from "./pages/Contact";
import Destination from "./pages/Destination";
import Landing from "./pages/Landing";
import Builder from "./pages/Builder";
import Review from "./pages/Review";
import Admin from "./pages/Admin";
import TradeAccess from "./pages/TradeAccess";
import { PaymentSuccess, PaymentCancel } from "./pages/PaymentResult";
import TripDashboard from "./pages/TripDashboard";
import MarketingPartner from "./pages/MarketingPartner";
import AdventureLanding from "./pages/AdventureLanding";
import BookingStatus from "./pages/BookingStatus";
import ConsentBanner from "./components/ra/ConsentBanner";
import { MarketProvider } from "./lib/market";

function App() {
  return (
    <div className="App">
      <MarketProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<RAHome />} />
          <Route path="/intro" element={<CallingCard />} />
          <Route path="/video-review/:token" element={<VideoReviewRecord />} />
          <Route path="/reviews" element={<VideoReviews />} />
          <Route path="/tours" element={<Tours />} />
          <Route path="/tours/:slug" element={<TourDetail />} />
          <Route path="/experience/:token" element={<TourDetail />} />
          <Route path="/destinations/:slug" element={<Destination />} />
          <Route path="/nepal-cycling-tours" element={<NepalCycling />} />
          <Route path="/about" element={<About />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/trade" element={<TradeAccess />} />
          <Route path="/build" element={<Landing />} />
          <Route path="/build/:region" element={<Builder />} />
          <Route path="/journey/:id" element={<Review />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/trip/:token" element={<TripDashboard />} />
          <Route path="/mpn" element={<MarketingPartner />} />
          <Route path="/adventures/:slug" element={<AdventureLanding />} />
          <Route path="/booking/:ref" element={<BookingStatus />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
      <ConsentBanner />
      </MarketProvider>
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#2B4C3E", color: "#fff", border: "none",
            borderRadius: "4px", fontFamily: "Manrope, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
